import type { Index } from "./planner";

let worker: Worker | null = null;
let ready: Promise<void> | null = null;
let signalReady: () => void;
const whenReady = new Promise<void>((r) => (signalReady = r));
let seq = 0;
const pending = new Map<number, (r: SearchHit[]) => void>();
export interface SearchHit { id: string; score: number; name: boolean }

export function initSearch(idx: Index) {
  if (ready) return ready;
  worker = new Worker(new URL("./search.worker.ts", import.meta.url), { type: "module" });
  const teachers = new Map<string, Set<string>>();
  for (const s of idx.core.sessions) if (s.lecturer) (teachers.get(s.course_id) ?? teachers.set(s.course_id, new Set()).get(s.course_id)!).add(s.lecturer);
  const docs = idx.core.courses.map((c) => ({
    id: c.id, name: c.name, name_en: c.name_en || "", code: c.code || "", dept: [c.department, ...(c.programs || [])].filter(Boolean).join(" "),
    teachers: [...(c.lecturers || []).map((l) => l.name), ...(teachers.get(c.id) || [])].join(" "), desc: c.description || "",
  }));
  ready = new Promise((res) => {
    worker!.onmessage = (e) => {
      if (e.data.type === "ready") res();
      if (e.data.type === "results") { pending.get(e.data.id)?.(e.data.res); pending.delete(e.data.id); }
    };
  });
  worker.postMessage({ type: "init", docs });
  ready.then(() => signalReady());
  return ready;
}

export async function search(q: string): Promise<SearchHit[]> {
  await whenReady;
  const id = ++seq;
  return new Promise((res) => { pending.set(id, res); worker!.postMessage({ type: "search", q, id }); });
}
